// extracted by mini-css-extract-plugin
export var closeButton = "_2b-3";
export var header = "_2b-0";
export var link = "_2b-1";
export var retryButton = "_2b-2";